import { FaxSendResponse } from "../../data-model/faxStatusModel";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logDataToConsole } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

interface SendFaxRequest {
  form_id: string;
  org_id: string;
  file_path: string;
}

export const sendFax = async (
  payload: SendFaxRequest,
): Promise<FaxSendResponse> => {
  try {
    const token = await getBearerToken();

    const response = await fetch(API_ENDPOINTS.SEND_FAX_FROM_CONFIG, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    const result = await response.json();
    return result;
  } catch (error) {
    logDataToConsole("error in sendFax", error);
    throw error;
  }
};
